<template>
  <div>
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Envelope</span><br />
          <span class="script">Shower</span>
        </h2>

        <p ref="textoRef" class="texto">
          Your presence is the most valuable gift to me. ✨  
          But if you wish to give a token of appreciation, I will receive it with love. 
<br><br> Gifts will be welcome.        </p>

        <img ref="sobreRef" :src="sobrePng" class="icono-sobre" alt="Sobre" />

        <p ref="lluviaTextoRef" class="lluvia-texto"></p>

        <p ref="graciasRef" class="gracias">THANK YOU!</p>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div>
    </section>

    </div>
</template><script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    // Refs del DOM
    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)

    // Contenedores de lluvia
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    let ctx; // Para limpieza fácil de GSAP

    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 12) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        el.style.position = 'absolute'
        el.style.width = '40px' // Ajusta según tu diseño
        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.8)
        const rndDur = gsap.utils.random(2, 3)
        const xStart = lado === 'der' ? 100 : -20
        const xEnd = lado === 'der' ? -30 : 110

        gsap.fromTo(el,
          { xPercent: xStart, yPercent: -20, rotate: gsap.utils.random(-30, 30), opacity: 0, scale: 0.4 },
          {
            xPercent: xEnd,
            yPercent: 130,
            rotate: gsap.utils.random(100, 360),
            opacity: 0.8,
            scale: gsap.utils.random(0.5, 0.8),
            duration: rndDur,
            delay: rndDelay,
            ease: 'none',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      ctx = gsap.context(() => {
        // --- ANIMACIÓN BLOQUE 1 ---
        const tl1 = gsap.timeline({
          scrollTrigger: {
            trigger: raiz.value,
            start: "top 75%", // Se activa cuando el elemento está al 75% del viewport (más visible)
            toggleActions: "play none none none",
            once: true
          }
        })

        tl1.from([tituloRef.value.querySelector('.serif'), tituloRef.value.querySelector('.script')], {
          y: 50,
          opacity: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: "back.out(1.7)"
        })
        .from(textoRef.value, { opacity: 0, y: 30, duration: 0.6 }, "-=0.4")
        .from(sobreRef.value, { 
          scale: 0, 
          rotation: -45, 
          opacity: 0, 
          duration: 0.8, 
          ease: "elastic.out(1, 0.7)" 
        }, "-=0.3")
        .from(lluviaTextoRef.value, { opacity: 0, y: 20 }, "-=0.5")
        .add(() => {
          crearLluvia(lluviaDer.value, 'der')
          crearLluvia(lluviaIzq.value, 'izq')
        }, "-=0.5")

        // --- ANIMACIÓN BLOQUE 2 (ZELLE) ---
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: raizNinos.value,
            start: "top 80%",
            once: true
          }
        })

        tl2.from(tituloNinosRef.value, { x: -50, opacity: 0, duration: 0.8 })
           .from(textoNinosRef.value, { x: 50, opacity: 0, duration: 0.8 }, "-=0.6")
           .add(() => {
             crearLluvia(lluviaNinosDer.value, 'der', 8)
             crearLluvia(lluviaNinosIzq.value, 'izq', 8)
           }, "-=0.4")

      }, raiz.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert() // Limpia todo (ScrollTriggers, animaciones, etc.)
    })

    return {
      raiz, tituloRef, textoRef, sobreRef, lluviaTextoRef,
      raizNinos, tituloNinosRef, 
      textoNinosRef, lluviaNinosIzq, lluviaNinosDer, sobrePng
    }
  }
}
</script>


<style scoped>
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #f0c9d3;
  overflow: hidden;
}
.contenido{ position: relative; z-index: 2;  }

.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.texto{
  font-family: 'quote', serif;
  color: #fff;
  font-size: 18px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto 18px;
  opacity: .95;
}

.icono-sobre{
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq{ left: 0; }
.lluvia-der{ right: 0; }

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
  .icono-sobre{ width: 96px; }
}
.lluvia-texto{
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: .05em;
  opacity: .95;
}
</style>
